export const CATEGORY_MODA_KEYS = ["reparto", "categoria", "tipo", "sottotipo", "persona"];
// Stesso proprietario già usato dalla pagina Map categorie; il backend resta l'autorità.
export const PROTECTED_MAPPING_USERNAME = "d.fenoglio@vigliettisport.com";
export const canEditProtectedMapping = (candidate, username) =>
  !candidate?.protected || String(username || "").trim().toLowerCase() === PROTECTED_MAPPING_USERNAME;

export const categoryCombinationKey = (moda) =>
  CATEGORY_MODA_KEYS.map((key) => moda?.[key] || "__EMPTY__").join("|");

export const defaultConflictsHref = (key) =>
  "/conflittiDefaultCategorie" + (key ? `?combination=${encodeURIComponent(key)}` : "");

export const missingDefaultSites = (outputs, defaults) => ["VIG", "BOT"].filter(
  (site) => outputs?.[site]?.length &&
    !outputs[site].some((id) => String(id) === String(defaults?.[site] || "")),
);

// Riscontro visivo per i payload resolver precedenti, già normalizzati dal server.
export const conflictsFromMappings = (mappings = [], fallbackSite) => {
  const sites = {};
  mappings.filter((mapping) => mapping.isDefaultCandidate).forEach((mapping) => {
    const site = mapping.site || fallbackSite;
    if (!site) return;
    const categoryId = Number(mapping.categoryId || mapping.externalCategoryId);
    if (!Number.isFinite(categoryId) || categoryId <= 0) return;
    sites[site] = sites[site] || { categoryIds: [], candidates: [] };
    if (!sites[site].categoryIds.includes(categoryId)) sites[site].categoryIds.push(categoryId);
    sites[site].candidates.push({ ...mapping, categoryId });
  });
  return Object.fromEntries(Object.entries(sites).filter(([, value]) => value.categoryIds.length > 1));
};

export const conflictDefaultsLabel = (conflict) => (conflict?.categoryIds || []).map((id) => {
  const candidate = conflict.candidates?.find((item) => Number(item.categoryId) === Number(id));
  return `${id} - ${candidate?.categoryPath || candidate?.categoryLabel || "Categoria"}`;
}).join("; ");

export const conflictsFromVerification = (verification) => Object.fromEntries(
  Object.entries(verification?.sites || {}).filter(([, value]) => value.ambiguousArticles > 0)
    .map(([site, value]) => [site, {
      categoryIds: [...new Set(value.groups.flatMap((group) => group.categoryIds))],
      candidates: value.groups.flatMap((group) => group.candidates),
    }]),
);
